
import { Vue } from 'vue-class-component';
import { useRoute } from 'vue-router';
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus';
import router from '@/router';
import UpdateIMUserModel from '@/models/imusers/updateIMUserModel';
import IMUserService from '@/services/imUserService';
import ErrorCode from '@/constants/ErrorCode';
import * as countryAreaCode from '@/assets/data/countryAreaCode.json';
import * as genderCode from '@/assets/data/genderCode.json';
import Status from '@/constants/Status';
import UpdateStatusModel from '@/models/imusers/updateStatusModel';
import CommonValidate from '@/services/commonValidate';

export default class IMUserDetail extends Vue {
  private model: UpdateIMUserModel = new UpdateIMUserModel();

  private countryAreaCodes = (countryAreaCode as any).default;

  private genderCodes = (genderCode as any).default;

  private userId='';

  private appId = '';

  private rules = {
    name: [{
      required: true, whitespace: true, message: '请输入用户名', trigger: 'blur',
    }, { validator: CommonValidate.validateUserName, trigger: 'blur' }],
    gender: [
      { required: true, message: '请选择性别', trigger: 'change' },
    ],
    phoneNo: [{
      required: true, whitespace: true, message: '请输入手机号码', trigger: 'blur',
    }, { validator: CommonValidate.validatePhone, trigger: 'blur' }],
  };

  mounted(): void {
    this.userId = useRoute().params.userId as string;
    this.appId = this.$route.params.appId as string;
    this.loadData();
  }

  loadData(): void {
    IMUserService.get(this.userId, this.appId)
      .then((result) => {
        if (result.code === ErrorCode.Success) {
          this.model.name = result.data.name;
          this.model.gender = result.data.gender;
          this.model.code = result.data.code;
          this.model.remark = result.data.remark;
          this.model.phoneNo = result.data.phoneNo.split('-')[1] as string;
          this.model.phonePrefix = result.data.phoneNo.split('-')[0] as string;
          this.model.status = result.data.status;
          this.model.creationDate = result.data.creationDate;
        }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  goBack():void {
    router.back();
  }

  save(): void {
    const updateform: any = this.$refs.form;
    updateform.validate((valid: boolean) => {
      if (valid) {
        const loadingInstance = ElLoading.service({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        IMUserService.update(this.userId, this.model, this.appId).then(
          (response) => {
            loadingInstance.close();
            if (response.code === ErrorCode.Success) {
              ElMessage.success(response.msg);
            } else {
              ElMessage.error(response.msg);
            }
          },
        ).catch((err) => {
          loadingInstance.close();
          console.error(err);
          if (err && err.msg) {
            ElMessage.error(err.msg);
          } else if (err) {
            ElMessage.error(err);
          }
        });
      }
    });
  }

  enable():void {
    const msg = '你确定要启用当前用户?';
    const updateModel = new UpdateStatusModel(this.userId, Status.正常);
    ElMessageBox.confirm(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        IMUserService.updateStatus(updateModel, this.appId)
          .then((response) => {
            if (response.code === ErrorCode.Success) {
              ElMessage.success(response.msg);
              this.model.status = Status.正常;
            } else {
              ElMessage.error(response.msg);
            }
          })
          .catch((response) => {
            ElMessage.error(response.msg);
          });
      });
  }

  disable():void {
    const msg = '你确定要禁用当前用户?';
    const updateModel = new UpdateStatusModel(this.userId, Status.禁用);
    ElMessageBox.confirm(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        IMUserService.updateStatus(updateModel, this.appId)
          .then((response) => {
            if (response.code === ErrorCode.Success) {
              ElMessage.success(response.msg);
              this.model.status = Status.禁用;
            } else {
              ElMessage.error(response.msg);
            }
          })
          .catch((response) => {
            ElMessage.error(response.msg);
          });
      });
  }
}
